import { ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import { grey } from '@mui/material/colors';

type Props = {
  key: string;
  label: ReactNode;
  period1: string;
  period2: string;
  period3: string;
};

export default function getCustomRow({
  key,
  label,
  period1,
  period2,
  period3,
}: Props) {
  return [
    getCustomRowCell(key, label),
    getCustomRowCell('period1', period1),
    getCustomRowCell('period2', period2),
    getCustomRowCell('period3', period3),
  ];
}

function getCustomRowCell(key: string, label: ReactNode) {
  return {
    key,
    content:
      typeof label === 'string' ? (
        <Typography variant="h6">{label}</Typography>
      ) : (
        label
      ),
    backgroundColor: grey[50],
  };
}
